<template>
  <PopoverRoot v-model:open="isOpen">
    <PopoverTrigger as-child>
      <span
        v-if="isHover"
        class="popover-trigger-wrap"
        @mouseenter="isOpen = true"
        @mouseleave="isOpen = false"
      >
        <slot />
      </span>
      <slot v-else />
    </PopoverTrigger>
    <PopoverPortal>
      <PopoverContent
        :side="side"
        :align="align"
        :side-offset="distance"
        :align-offset="skidding"
        :collision-padding="8"
        class="popover-content"
        @interact-outside="handleInteractOutside"
        @mouseenter="isHover && (isOpen = true)"
        @mouseleave="isHover && (isOpen = false)"
      >
        <slot name="popper" :hide="close" />
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>

<script>
import { ref, computed, watch } from 'vue'
import {
  PopoverRoot,
  PopoverTrigger,
  PopoverPortal,
  PopoverContent,
} from 'reka-ui'

export default {
  name: 'Popover',
  components: {
    PopoverRoot,
    PopoverTrigger,
    PopoverPortal,
    PopoverContent,
  },
  props: {
    triggers: {
      type: Array,
      default: () => ['click'],
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    skidding: { type: Number, default: 0 },
    distance: { type: Number, default: 10 },
  },
  emits: ['show', 'hide'],
  setup(props, { emit, expose }) {
    const isOpen = ref(false)

    const isHover = computed(() => props.triggers.includes('hover'))

    // Parse placement into side + align for reka-ui
    const side = computed(() => {
      const s = props.placement.split('-')[0]
      return ['top', 'bottom', 'left', 'right'].includes(s) ? s : 'bottom'
    })

    const align = computed(() => {
      const parts = props.placement.split('-')
      if (parts[1] === 'start') return 'start'
      if (parts[1] === 'end') return 'end'
      return 'center'
    })

    watch(isOpen, (open) => {
      emit(open ? 'show' : 'hide')
    })

    const close = () => {
      isOpen.value = false
    }

    const handleInteractOutside = () => {
      close()
    }

    expose({ close })

    return {
      isOpen,
      isHover,
      side,
      align,
      close,
      handleInteractOutside,
    }
  },
}
</script>

<style scoped>
.popover-trigger-wrap {
  display: inline-flex;
}
</style>

<!-- Portal styles in ui-elements.scss -->
